"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const RoleDropdown_1 = tslib_1.__importDefault(require("./RoleDropdown"));
const RoleCell = ({ host, role, readonly = false, onEditRole }) => !readonly && onEditRole ? (react_1.default.createElement(RoleDropdown_1.default, { host: host, onEditRole: onEditRole, current: role })) : (react_1.default.createElement("span", null, role));
exports.default = RoleCell;
//# sourceMappingURL=RoleCell.js.map